export enum MembershipType {
  TRIAL = 'trial',
  SUBSCRIPTION = 'subscription',
}